export default {
  quantities: ['4', '8', '16', '32'],
  part_number: '',
  revision: '',
  number_of_layers: '2',
  board_length: '',
  board_width: '',
  silkscreen_sides: 'Both Sides',

  blind_buried_hole: 'none',
  material_type: 'FR4TG180',
  finish_plating: 'Immersion Gold (ENIG)',
  gold_fingers: '0',
  material_thickness: '0.062',
  copper_inners: '1 oz',
  copper_outers: '1 oz',
  min_trace_space: 0.005,
  solder_sides: 'Both Sides',
  ezq_job_number: '',
  solder_color: 'green',
  silkscreen_color: 'White',
};
